import { render, staticRenderFns } from "./PlaygroundUpDown.vue?vue&type=template&id=a1a76744&"
import script from "./PlaygroundUpDown.vue?vue&type=script&lang=js&"
export * from "./PlaygroundUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports